import { render, staticRenderFns } from "./confirm-delete.vue?vue&type=template&id=d5ac3160&"
import script from "./confirm-delete.vue?vue&type=script&lang=js&"
export * from "./confirm-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports